import { DashboardContainer } from '@forwardflow/components/Dashboard'
import { Outlet, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { CampaignActivationModal } from '@forwardflow/modals/CampaignActivationModal'

import { TopBar } from './TopBar'
import { LeadSourceInfo } from './LeadSourceInfo'
import { NavigationBar } from './NavigationBar'
import { useGetActiveLeadSourceDetails } from '../../hooks'
import CampaignService from '@forwardflow/services/CampaignService'
import { CampaignLiveModal } from '@forwardflow/modals/CampaignLiveModal'

export const ConfigCampaignPage = () => {
   const { title } = useParams()

   const { data: organizationCampaignDetails } = useGetActiveLeadSourceDetails(
      title as string
   )

   useEffect(() => {
      const handleBeforeUnload = () => {
         CampaignService.discardDraftCampaign(title as string)
      }

      window.addEventListener('beforeunload', handleBeforeUnload)

      return () => {
         window.removeEventListener('beforeunload', handleBeforeUnload)
         CampaignService.discardDraftCampaign(title as string)
      }
   }, [title])

   return (
      <DashboardContainer>
         <div className="flex flex-col h-full">
            <TopBar />
            <div className="flex gap-5 mt-5 flex-1 min-h-0 overflow-hidden">
               <LeadSourceInfo />
               <div className="flex flex-1 bg-primary/10 rounded-xl">
                  <NavigationBar />
                  <Outlet />
               </div>
            </div>

            {organizationCampaignDetails &&
               organizationCampaignDetails?.status === 'draft' && (
                  <>
                     <CampaignActivationModal />
                  </>
               )}
            <CampaignLiveModal />
         </div>
      </DashboardContainer>
   )
}
